import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Settings as SettingsIcon } from 'lucide-react';
import './SettingsScreen.css';

export default function SettingsScreen() {
  const { userProfile } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="settings-screen">
      <div className="screen-header">
        <div>
          <h1>Settings</h1>
          <p>Manage your admin account settings</p>
        </div>
      </div>

      <div className="settings-content">
        <div className="settings-card">
          <h2>Account Information</h2>
          <div className="settings-item">
            <span className="settings-label">Display Name</span>
            <span className="settings-value">{userProfile?.displayName || 'N/A'}</span>
          </div>
          <div className="settings-item">
            <span className="settings-label">Email</span>
            <span className="settings-value">{userProfile?.email || 'N/A'}</span>
          </div>
          <div className="settings-item">
            <span className="settings-label">Role</span>
            <span className="settings-value">
              <span className="role-badge admin">{userProfile?.role || 'N/A'}</span>
            </span>
          </div>
        </div>

        <div className="settings-card">
          <h2>System Information</h2>
          <div className="settings-item">
            <span className="settings-label">Admin Dashboard Version</span>
            <span className="settings-value">1.0.0</span>
          </div>
          <div className="settings-item">
            <span className="settings-label">Environment</span>
            <span className="settings-value">
              {import.meta.env.MODE === 'production' ? 'Production' : 'Development'}
            </span>
          </div>
        </div>

        <div className="settings-card">
          <h2>Administration</h2>
          <div className="settings-item">
            <span className="settings-label">Disabled Reasons</span>
            <span className="settings-value">
              <button
                className="link-button"
                onClick={() => navigate('/settings/disabled-reasons')}
              >
                <SettingsIcon size={16} />
                <span>Manage Disabled Reasons</span>
              </button>
            </span>
          </div>
          <p className="settings-description">
            Configure reasons for account deactivation. These reasons are shown when deactivating family accounts.
          </p>
        </div>
      </div>
    </div>
  );
}

